import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { STORAGE } from '@shared/constants/storage.constants';
import { StorageService } from '@shared/services/storage/storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const accessToken = storageService.get(STORAGE.ACCESS_TOKEN);
  const excludeList: string[] = [];

  if (accessToken) {
    req = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + accessToken),
    });
  }

  if (!req.headers.has('Content-Type') && !excludeList.includes(req.url)) {
    req = req.clone({
      headers: req.headers.set('Content-Type', 'application/json'),
    });
  }
  return next(req);
};